import { defineComponent as _defineComponent } from 'vue'
import { computed } from 'vue';
import { faPlay } from '@fortawesome/free-solid-svg-icons';
// EXP_PROMOTED_FREE_TRIAL_REDESIGN
import { usePromotedFreeTrialRedesignExp } from '@/components/experiments/PromotedFreeTrialRedesignExp';
// EXP_PROMOTED_FREE_TRIAL_REDESIGN


export default /*#__PURE__*/_defineComponent({
  __name: 'PromotionRowCTA',
  props: {
    isHighlighted: { type: Boolean },
    hasPromotionTag: { type: Boolean },
    fullWidth: { type: Boolean },
    providerShortName: null,
    isFallback: { type: Boolean }
  },
  setup(__props: any) {

const props = __props as {
	isHighlighted?: boolean;
	hasPromotionTag?: boolean;
	fullWidth?: boolean;
	// EXP_PROMOTED_FREE_TRIAL_REDESIGN: only the free trial row passes these - other callers (SQTV, QTV, etc.)
	// leave them undefined, which keeps this button out of the experiment entirely.
	providerShortName?: string;
	isFallback?: boolean;
};



// EXP_PROMOTED_FREE_TRIAL_REDESIGN - variant_1, variant_2 and variant_4 use the neutral (non-yellow) button; variant_3 and control use yellow.
const { variant: pftrVariant } = usePromotedFreeTrialRedesignExp(
	() => props.providerShortName,
	() => !!props.isFallback
);
const NEUTRAL_PFTR_VARIANTS = ['variant_1', 'variant_2', 'variant_4'];
const isNeutralPftrVariant = computed(() => NEUTRAL_PFTR_VARIANTS.includes(pftrVariant.value ?? ''));
// EXP_PROMOTED_FREE_TRIAL_REDESIGN

return { __sfc: true,props, pftrVariant, NEUTRAL_PFTR_VARIANTS, isNeutralPftrVariant, faPlay }
}

})